export default {"src":"/_next/static/media/logo1.3c31d863.svg","height":16,"width":50,"blurWidth":0,"blurHeight":0};